import { defaultTo } from "lodash";
import { IModel, Model, ModelRecord } from "./Model";
import { AuthApplicationModel } from "./Security";

export interface IPetAlertModel extends IModel {
    petAlertId: number;
    name: string;
    sortOrder: number;
    petAlertTypeId: number;
    authApplications: AuthApplicationModel[];
}

export class PetAlertModel extends Model implements ModelRecord<IPetAlertModel> {
    petAlertId: number;
    name: string;
    sortOrder: number;
    petAlertTypeId: number;
    authApplications: AuthApplicationModel[]

    constructor(params?: Partial<IPetAlertModel>) {
        super(params);

        this.petAlertId = defaultTo(params?.petAlertId, 0);
        this.name = defaultTo(params?.name, '');
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.petAlertTypeId = defaultTo(params?.petAlertTypeId, 0);
        this.authApplications = (params?.authApplications ?? []).map(au => new AuthApplicationModel(au));
    }
}
